var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{ref:"formValidate",attrs:{"model":_vm.formValidate,"rules":_vm.ruleValidate,"label-width":150}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }